var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9f00",
    d: "M40 12H22l-4-4H8c-2.2 0-4 1.8-4 4v24a4 4 0 0 0 4 4h29.682L44 29V16c0-2.2-1.8-4-4-4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44 21.1v14.97a4 4 0 0 1-4 4H10.318L4 29.07V21.1Z",
    style: {
      fill: "#ff9f00",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accddc",
      fillOpacity: 1,
      strokeWidth: 1.05263
    },
    d: "M40 13H30V3Z",
    transform: "matrix(.60629 0 0 .60629 15.343 .141)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#b8b8b8",
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M40 45H8V3h22l10 10z",
    transform: "matrix(.60629 0 0 .60629 15.343 .141)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      fillOpacity: 1,
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M40 13H30V3Z",
    transform: "matrix(.60629 0 0 .60629 15.343 .141)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 42V12h30v30z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.174419,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    transform: "matrix(.60629 0 0 .60629 15.343 .141)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fontSize: "none",
    fontWeight: "none",
    strokeMiterlimit: 10,
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.933 23.915V8.15h15.763v15.765z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.583
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.11 12.692a6.59 6.59 0 0 0-1.506-2.976 6.49 6.49 0 0 1 3.769 2.817 6.483 6.483 0 0 0-2.263.16m-8.21 7.693a6.593 6.593 0 0 0 4.252 2.181 6.53 6.53 0 0 1-.862-2.127 6.53 6.53 0 0 1-3.39-.053m6.818 1.93a6.57 6.57 0 0 0 4.381-8.193 6.408 6.408 0 0 0-.727-1.598 6.515 6.515 0 0 0-2.27.166 6.573 6.573 0 0 1-.295 3.741 6.544 6.544 0 0 1-4.524 4.007c.158.757.453 1.476.862 2.127a6.501 6.501 0 0 0 2.573-.25",
    fill: "#59baea"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.29 20.44a6.569 6.569 0 0 1 .287-3.742 6.555 6.555 0 0 1 4.533-4.006 6.553 6.553 0 0 0-1.506-2.976 6.52 6.52 0 0 0-3.693.03 6.568 6.568 0 0 0-4.38 8.194 6.56 6.56 0 0 0 1.37 2.454c1.142.318 2.3.318 3.389.046",
    fill: "#586e7c"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#accddc",
      fillOpacity: 1,
      strokeWidth: 0.638199
    },
    d: "M32.694 13.818h-6.063V7.755Z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#b8b8b8",
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M40 45H8V3h22l10 10z",
    transform: "matrix(.60629 0 0 .60629 8.443 5.936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8b8b8",
      fillOpacity: 1,
      strokeWidth: 1.5,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M40 13H30V3Z",
    transform: "matrix(.60629 0 0 .60629 8.443 5.936)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 31.4V13.212h18.188V31.4z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.105748,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.033 29.71V13.945h15.763V29.71Z",
    style: {
      mixBlendMode: "normal",
      fill: "none",
      strokeWidth: 0.509257,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.939 122.702v-172h172v172Z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 48.169c.358-2.51.717-5.017.717-7.884 0-2.866-.359-5.375-.717-7.883l16.125-11.467c1.433-1.075 2.15-3.225 1.075-5.016l-15.767-26.517c-1.075-1.792-2.866-2.508-4.658-1.433L97.82-3.791c-4.3-3.224-8.6-5.732-13.616-7.882l-1.792-19.708c-.358-1.792-1.792-3.225-3.583-3.225H48.011c-1.792 0-3.583 1.433-3.583 3.225l-1.792 19.708C37.62-9.523 32.961-7.015 29.02-3.79l-17.917-8.241c-1.79-.717-3.94 0-4.658 1.433L-8.964 15.919c-1.075 1.79-.358 3.94 1.075 5.016L8.236 32.402c-.358 2.508-.717 5.017-.717 7.883 0 2.867.36 5.375.717 7.884L-8.606 59.635c-1.433 1.075-2.15 3.225-1.075 5.017L5.727 91.169c1.075 1.79 2.867 2.508 4.66 1.433l17.915-8.242c4.3 3.225 8.6 5.734 13.617 7.884l1.792 19.708c.358 1.792 1.792 3.225 3.583 3.225h30.817c1.792 0 3.583-1.433 3.583-3.225l1.792-19.708c5.017-2.15 9.675-4.66 13.617-7.884l17.916 8.242c1.792.717 3.942 0 4.66-1.433l15.407-26.517c1.075-1.792.358-3.942-1.075-5.017zm-55.9 27.95c-19.708 0-35.833-16.125-35.833-35.833 0-19.71 16.125-35.834 35.833-35.834s35.833 16.125 35.833 35.834c0 19.708-16.125 35.833-35.833 35.833z",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "#677b84",
      fillOpacity: 1,
      strokeMiterlimit: 10
    },
    fill: "#607d8b",
    transform: "matrix(.0885 0 0 .0885 17.41 18.288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.061-2.715c-23.65 0-43 19.35-43 43s19.35 43 43 43 43-19.35 43-43-19.35-43-43-43zm0 60.917c-10.033 0-17.917-7.883-17.917-17.917 0-10.033 7.884-17.916 17.917-17.916 10.033 0 17.917 7.883 17.917 17.916 0 10.034-7.884 17.917-17.917 17.917z",
    fill: "#455a64",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      strokeMiterlimit: 10
    },
    transform: "matrix(.0885 0 0 .0885 17.41 18.288)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block",
      fill: "#ffd42a",
      fillOpacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc928",
    fillOpacity: 1,
    d: "M18.2-8H-8.7c-1.9 0-3.6 1.4-3.9 3.3l-3.289 18.088L-16 14h31.7c1.899 0 3.6-1.4 3.899-3.3l2.5-14C22.599-5.7 20.7-8 18.2-8Z",
    style: {
      fill: "#ffd42a",
      fillOpacity: 0.8
    },
    transform: "translate(24.44 26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLibrary);
export default __webpack_public_path__ + "static/media/fileLibrary.15c77f5e34e868cd2433d49375b1de1f.svg";
export { ForwardRef as ReactComponent };